import React from 'react'
import Paged from 'components/common/Paged'
import { Translate } from 'utils/translate'
import { useReport } from './hooks'
import * as R from 'ramda'

import { TAB_NAMES, getFactors } from 'components/modals/TestsReportModal/model'

import { IntroPage } from './components/IntroPage/IntroPage'
import { Competencies } from './components/Competencies/Competencies'
import { GMAPage } from './components/GMA/GMA'
import { PersonalityOverview } from './components/Personality/PersonalityOverview'
import { PersonalityTrait } from './components/Personality/PersonalityTrait'
import { BackCover } from './components/BackCover/BackCover'

export const Report = ({ isCandidate = false }) => {
  const {
    state: {
      language,
      name,
      scores,
      visibleCategories,
      explanations,
      project,
      radarData,
      respondent,
    },
    handlers: { getTraitScores, getScoreLabel },
  } = useReport()

  if (!scores || !project) return null

  const personalityFactors = R.filter(
    R.propEq('parentId', TAB_NAMES.PERSONALITY),
    getFactors(isCandidate),
  )

  const noCategories =
    R.isEmpty(project?.profile?.categories) ||
    visibleCategories.scores?.length > 10 ||
    visibleCategories.scores.every(({ score }) => isNaN(score))

  const noPersonality = personalityFactors.every(({ factor }) =>
    isNaN(scores?.[factor]),
  )

  const noGMA = isNaN(scores?.['GMA'])

  const showCompetenciesSection = !noCategories && !isCandidate
  const hasCompetenciesContent =
    showCompetenciesSection &&
    (visibleCategories.scores?.length ?? 0) > 0
  const pageBreakMarkerBeforeGma =
    hasCompetenciesContent && !noGMA

  return (
    <Translate {...{ language }}>
      {name && scores && (
        <Paged noFooter>
          <IntroPage
            projectName={project.name}
            noCategories={noCategories}
            noOutcomeFactors={noPersonality}
            noGMA={noGMA}
            {...{
              isCandidate,
              language,
              name,
              scores,
            }}
          />
          {noCategories || isCandidate ? null : (
            <Competencies
              data={visibleCategories.scores}
              radarData={radarData}
              getTraitScores={getTraitScores}
              explanations={explanations}
              getScoreLabel={getScoreLabel}
              language={language}
            />
          )}
          {pageBreakMarkerBeforeGma ? (
            <div
              className="pdf-section-break"
              aria-hidden
            />
          ) : null}
          {noGMA ? null : (
            <GMAPage
              response={[respondent]}
              scores={scores}
              language={language}
              isCandidate={isCandidate}
              candidates={[respondent]}
            />
          )}
          {noPersonality ? null : (
            <PersonalityOverview
              scores={scores}
              language={language}
              factors={personalityFactors}
              isCandidate={isCandidate}
            />
          )}
          {noPersonality
            ? null
            : personalityFactors.map(personalityFactor => {
                const personalityTab = personalityFactor.id
                const tabConfig = R.find(
                  R.propEq('id', personalityTab),
                  personalityFactors,
                )
                const factor = R.prop('factor', tabConfig)

                return (
                  <PersonalityTrait
                    key={factor}
                    groups={tabConfig?.groups}
                    response={[respondent]}
                    {...{
                      factor,
                      language,
                      scores,
                      isCandidate,
                    }}
                  />
                )
              })}
          <BackCover />
        </Paged>
      )}
    </Translate>
  )
}
